<script>
	import { onMount, onDestroy } from "svelte";
	import { navigate } from "svelte-routing";
	import { Button, Col, Row } from "@sveltestrap/sveltestrap";
	import queryString from "query-string";
	import Swal from "sweetalert2";
	import client from "../../../services/client";
	import {
		errorMessage,
		sizeSelect,
		totalPages,
		loading,
		initPage,
		cachedTaskLookups,
		masterData,
	} from "../../../store/store";
	import CarManagementTable from "./CarManagementTable.svelte";
	import ErrorMessageHandler from "../../../components/ErrorMessageHandler/ErrorMessageHandler.svelte";
	import PageHeader from "../../../components/PageHeader/PageHeader.svelte";
	import FilterForm from "../../../components/FilterForm/FilterForm.svelte";
	import LimitSize from "../../../components/SizeSelect/SizeSelect.svelte";
	import csvDownload from "json-to-csv-export";
	import { extractErrorMessage, handleCsvImport } from "src/utils/misc";
	import { fetchTaskLookups } from "src/services/lookupCache";
	import { cachedMasterData } from "src/services/profile";

	let data = [];
	let csvData = [];
	let carAssetOwners = [];

	$: lookups = $cachedTaskLookups;

	//Start Logic for filter feature
	const params = new Proxy(new URLSearchParams(window.location.search), {
		get: (searchParams, prop) => searchParams.get(prop),
	});
	$: queryParams = `?page=1&size=${$sizeSelect}`;
	let searchParams = window.location.search.toString();
	let querySize = searchParams.includes("size");
	let queryPage = searchParams.includes("page");
	let queryStatus = searchParams.includes("StatusIds");
	let queryPlateNumber = searchParams.includes("plateNumber");
	let queryStartDateRange = searchParams.includes("startDateRange");
	let queryEndDateRange = searchParams.includes("endDateRange");
	let queryCarmake = searchParams.includes("carMake");
	let queryCarpark = searchParams.includes("carpark");
	let pricingGroup = searchParams.includes("PriceGroupId");
	let carAssetOwnerId = searchParams.includes("carAssetOwnerId");
	let queryPlatform = searchParams.includes("platform");

	$: if (queryPage) {
		queryParams = `?page=${params.page}&size=${$sizeSelect}`;
	}
	$: if (queryPage && querySize) {
		queryParams = `?page=${params.page}&size=${$sizeSelect}`;
	}
	$: if (queryStatus) {
		let urlParams = new URLSearchParams(window.location.search);
		let statusIds = urlParams.getAll("StatusIds");
		statusIds.forEach((id) => {
			queryParams = queryParams.concat(`&StatusIds=${id}`);
		});
	}
	$: if (queryPlateNumber) {
		queryParams = queryParams.concat(`&Keyword=${params.plateNumber}`);
	}
	$: if (queryStartDateRange) {
		queryParams = queryParams.concat(`&startDate=${params.startDateRange}`);
	}
	$: if (queryEndDateRange) {
		queryParams = queryParams.concat(`&endDate=${params.endDateRange}`);
	}
	$: if (queryCarmake) {
		queryParams = queryParams.concat(`&makeId=${params.carMake}`);
	}
	$: if (queryCarpark) {
		queryParams = queryParams.concat(`&CarParkId=${params.carpark}`);
	}
	$: if (pricingGroup) {
		queryParams = queryParams.concat(
			`&PriceGroupId=${params.PriceGroupId}`
		);
	}
	$: if (carAssetOwnerId) {
		queryParams = queryParams.concat(
			`&carAssetOwnerId=${params.carAssetOwnerId}`
		);
	}
	$: if (queryPlatform) {
		let urlParams = new URLSearchParams(window.location.search);
		let platforms = urlParams.getAll("platform");
		platforms.forEach((id) => {
			queryParams = queryParams.concat(`&platform=${id}`);
		});
	}
	//End Logic for filter feature

	//FETCH Vehicle LIST

	const fetchVehicles = async () => {
		try {
			errorMessage.set("");
			const res = await client(`/v1/filter${queryParams}`, {
				method: "GET",
				version: "Vehicle",
			});
			data = res.data.dataList;
			data.totalCount = res.data.totalCount || 0;
			totalPages.set(res.data.totalPage);
			if (res.data.dataList) {
				loading.set(false);
			}
		} catch (err) {
			loading.set(false);
			extractErrorMessage(err);
			console.log(err);
		}
	};

	const fetchCarAssetOwners = async () => {
		try {
			const res = await client(
				`/v1/carAssetOwners/filter?Page=1&Size=100`,
				{
					method: "GET",
					version: "Vehicle",
				}
			);
			carAssetOwners = res.data.dataList;
		} catch (err) {
			console.log(err);
			extractErrorMessage(err);
		}
	};

	onMount(async () => {
		loading.set(true);
		errorMessage.set("");
		fetchVehicles();
		fetchCarAssetOwners();
		fetchTaskLookups();
		cachedMasterData();
	});

	let err;
	errorMessage.subscribe((value) => {
		err = value;
	});

	let dataList;
	let load;
	export const handleExportCSV = async () => {
		load = true;
		try {
			const res = await client("/v1/csvFileExport", {
				method: "POST",
				version: "Vehicle",
			});
			dataList = res.data;
			csvDownload({ data: dataList, filename: "CarList.csv" });
			load = false;
		} catch (err) {
			load = false;
			extractErrorMessage(err);
			console.log(err);
		}
	};

	onDestroy(() => {
		initPage.set(1);
		sizeSelect.set("20");
		totalPages.set(1);
	});
</script>

<Row>
	<Col xs={12}>
		<div>
			<ErrorMessageHandler message={err} />
			<Col className="row d-flex align-items-start mx-0">
				<PageHeader title="Car Management" />
			</Col>
			<div class="d-flex flex-row">
				<Col xs={6}>
					<FilterForm
						priceGroup
						plateNumber
						carStatus
						carMake
						carpark
						startDateRange
						endDateRange
						carAssetOwner={carAssetOwners}
						platform
					/>
				</Col>
				<Col class="d-flex justify-content-end" xs={6}>
					<div class="mx-2">
						<input
							id="fileInput"
							type="file"
							multiple={false}
							hidden="hidden"
							on:change={(e) =>
								handleCsvImport(
									e,
									"/v1/csvFileImport",
									"Vehicle"
								)}
						/>
						<label
							type="button"
							for="fileInput"
							id="customButton"
							class="btn themeButton primary px-4"
							block>Import CSV</label
						>
						<p>
							<a
								href="/assets/csv/Vehicle_Template.csv"
								target="_blank"
								download="vehicle_template.csv"
								rel="noreferrer"
								class="link link-text"
							>
								Download CSV Template
							</a>
						</p>
					</div>
					{#if !load}
						<div class="mx-2">
							<Button
								class="themeButton primary px-4"
								type="button"
								on:click={() => handleExportCSV()}
							>
								Export CSV
							</Button>
						</div>
					{:else if load}
						<div class="">
							<Button
								class="themeButton primary px-4"
								type="button"
								disabled
							>
								<output
									class="spinner-grow spinner-grow-sm"
									aria-hidden="true"
								/>
								Loading...
							</Button>
						</div>
					{/if}
					<div class="mx-2">
						<Button
							class="themeButton primary px-4"
							on:click={() => navigate("/car-management/create")}
							>Add car</Button
						>
						<div class="my-2">
							<LimitSize trigerSelect={fetchVehicles} />
						</div>
					</div>
				</Col>
			</div>
			<div />
		</div>
	</Col>
	<Col class="my-2">
		<CarManagementTable {data} {fetchVehicles} {lookups} />
	</Col>
</Row>

<style>
	:global(.link.svelte-gokig2) {
		color: #011851 !important;
		text-decoration: none !important;
		cursor: pointer;
	}
</style>
